import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-hotels-add-item-form',
  templateUrl: './hotels-add-item-form.component.html',
  styleUrls: ['./hotels-add-item-form.component.scss']
})
export class HotelsAddItemFormComponent implements OnInit {

  constructor() { }
  
  ngOnInit() {}
}
